import React, { createContext, useContext, useReducer } from "react";
import { mobileVerifyReducer } from "reducers/mobileVerificationReducer";
import { initialMobileVerify, initialMobileVerifyErrors } from "Data/mobileverification";

// Create context
export const MobileVerifyContext = createContext();

// Initial state
const initialState = {
  toggleMobileVerify: false,
  noOfStep: 3,
  step: 1,
  mobileVerify: initialMobileVerify,
  mobileVerifyErrors: initialMobileVerifyErrors,
};

// Provider
const MobileVerifyProvider = ({ children }) => {
  const [mobileVerifyState, mobileVerifyDispatch] = useReducer(mobileVerifyReducer, initialState);

  return (
    <MobileVerifyContext.Provider
      value={{
        ...mobileVerifyState,
        mobileVerifyDispatch,
      }}
    >
      {children}
    </MobileVerifyContext.Provider>
  );
};

// Custom hook
export const useMobileVerifyContext = () => useContext(MobileVerifyContext);

export default MobileVerifyProvider;
